module.exports = __webpack_public_path__ + "static/media/satisfaction@2x.9898c8ad.png";